<template>
  <div class="certificate-contact">
    <div class="certificate-name-en mb-4">{{ programData.title }}</div>
    <p class="certificate-description">{{ programData.description }}</p>

    <b-row >
      <b-col class="certificate-media" md="12" cols="12">
        <div>اهداف التدريب</div>
        <p class="certificate-description">{{ programData.goals }}</p>

      </b-col>
      <b-col class="certificate-media" md="12" cols="12">
        <div>محتوى التدريب</div>
        <p class="certificate-description">{{ programData.content }}</p>

      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  props: {
    programData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  methods: {},
};
</script>
<style lang="">
</style>
